import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';
const SvgIcon = createSvgIcon([
    React.createElement("path", { key: '0', d: 'M0.8,1h7.3c0,1,0,1-1.5,1v12.1c0,1.7,1.3,3,3,3h4.5c0-1.5,0-1.5,1.1-1.5V23c-1,0-1,0-1-1.5H9.7c-4.1,0-7.4-3.3-7.4-7.4l0,0\n            V2C0.8,2,0.8,2,0.8,1z' }),
], 'TransportFuelPipeSensor');
const TransportFuelPipeSensorIcon = function (props) {
    const colors = {
        fuelIn: '#6577ff',
        fuelOut: '#757575',
        disabled: '#ECEEFF',
    };
    return (React.createElement(SvgIcon, Object.assign({ sx: {
            path: {
                fill: colors[props.color],
            },
        } }, props)));
};
export default memo(TransportFuelPipeSensorIcon);
